export const ROUTES = {
  HOME: "/",
  LISTINGS: {
    BASE: "/listings",
    LISTING: {
      BASE: "/listings/[propertyId]",
      REVIEW: {
        BASE: "/listings/[propertyId]/review",
      },
      FREE_REVIEW: {
        BASE: "/listings/[propertyId]/free-review",
      },
    },
  },
  PROJECTS: {
    BASE: "/projects",
    DETAIL: "/projects/[projectId]",
  },
  USERS: {
    BASE: "/users",
  },
  QR_CODES: {
    BASE: "/qr-codes",
  },
  SEED_DATA: {
    BASE: "/admin/seed-data",
  },
};
